import { toUtcAdjusted } from '@noor/lib';
import type {
  OrderActor,
  OrderCourierOption,
  OrderVendorOption,
} from '../model/order-schema';

/* eslint-disable @typescript-eslint/prefer-nullish-coalescing --
   Ported verbatim from cpanel `TableFilters` `getOptionLabel`s; `||` lets an
   empty first/last name fall through like the original. */

type CourierLike = Pick<OrderCourierOption | OrderActor, 'first_name' | 'last_name'>;
type VendorLike = Pick<
  OrderVendorOption | OrderActor,
  'name' | 'business_name' | 'is_business'
>;

/** Courier filter label: `first last`, else `Courier <last|id>`. */
export function courierOptionLabel(courier: CourierLike, id: string | number): string {
  return `${courier.first_name || 'Courier'} ${courier.last_name || id}`;
}

/**
 * Vendor filter label: the business name for business vendors, else the
 * vendor name, else `Vendor <id>` (`withHash` = the option-row variant,
 * `Vendor #<id>`).
 */
export function vendorOptionLabel(
  vendor: VendorLike,
  id: string | number,
  withHash = false,
): string {
  if (vendor.is_business && vendor.business_name?.trim()) return vendor.business_name;
  if (vendor.name?.trim()) return vendor.name;
  return withHash ? `Vendor #${id}` : `Vendor ${id}`;
}

/** Page size of the courier/vendor option lists (cpanel `InfiniteSelect` limit). */
export const ORDER_FILTER_OPTIONS_PAGE_SIZE = 15;

/**
 * The orders window the filter options are scoped to: cpanel sent the list's
 * day window as `orders_from_date` / `orders_till_date` (same `toUtcAdjusted`
 * bounds as the list), so the selects only offer couriers/vendors with orders
 * in range.
 */
export function orderOptionsWindow(
  startDate: string | undefined,
  endDate: string | undefined,
): { orders_from_date: string; orders_till_date: string } {
  return {
    orders_from_date: toUtcAdjusted(startDate).toISOString(),
    orders_till_date: toUtcAdjusted(endDate).add(1, 'day').toISOString(),
  };
}
